import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from './Icons';
export function FAQSection() {
  const faqs = [{
    q: 'No tengo tiempo. Mi agenda está completamente saturada.',
    a: "El protocolo está diseñado específicamente para personas ocupadas. El 'Ayuno de los Primeros 15' son literalmente 15 minutos. La lectura contemplativa son 5 versículos. La práctica más larga de toda la semana es una caminata sin auriculares. Si tienes 15 minutos al día, tienes lo que necesitas."
  }, {
    q: '¿Esto es para una denominación específica? Soy católico / evangélico / carismático...',
    a: 'Intimidad Radical está basado exclusivamente en los Evangelios y la tradición espiritual cristiana más amplia — desde los Padres del Desierto hasta Dallas Willard. Es para cualquier seguidor de Jesús que quiera una relación más profunda con Él, independientemente de su denominación.'
  }, {
    q: '¿Y si en el silencio no siento nada?',
    a: 'Lo que sientes durante la práctica no mide su efectividad. Las transformaciones más profundas ocurren frecuentemente en los días en que menos se siente algo. El protocolo aborda específicamente las épocas de sequía espiritual y te da herramientas concretas para navegarlas sin abandonar el camino.'
  }, {
    q: 'Tengo heridas religiosas profundas. ¿Este protocolo es para mí también?',
    a: 'Hay una sección completa dedicada específicamente a personas con heridas espirituales. El protocolo distingue claramente entre Jesús de Nazaret — el que está del mismo lado que tú frente al daño que la religión te hizo — y las instituciones que lo representaron de forma distorsionada.'
  }, {
    q: '¿Es un libro físico o digital?',
    a: 'Es un producto digital de acceso inmediato. Puedes empezar en los próximos 2 minutos en tu tablet, móvil o computadora. También puedes imprimirlo completo si prefieres leer sin pantallas (lo cual, por cierto, está muy alineado con el protocolo).'
  }, {
    q: '¿Qué pasa después de los 30 días? ¿Se acaba?',
    a: 'El protocolo incluye una sección completa sobre cómo construir una práctica sostenible más allá de los 30 días, incluyendo un ritmo semanal sugerido, las trampas que evitar después del protocolo y cómo sostener los hábitos sin que se conviertan en un nuevo sistema de obligaciones religiosas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-cream-dark pt-12 pb-24 px-4" data-id="element-43">
      <div className="max-w-3xl mx-auto" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-45">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-dark mb-6" data-id="element-46">
            Preguntas Frecuentes
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto" data-id="element-47" />
        </motion.div>

        <div className="space-y-4" data-id="element-48">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-lg border border-dark/10 overflow-hidden" data-id="element-49">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-50">
                <span className="font-bold text-lg text-dark pr-4" data-id="element-51">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-52">
                  <ChevronDownIcon className="w-5 h-5 text-gold flex-shrink-0" data-id="element-53" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-54">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-55">
                    <div className="px-6 pb-5 text-dark/70 leading-relaxed border-t border-dark/5 pt-4" data-id="element-56">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}